<template>
  <div :class="aditionalClass">
    <div class="md-form" :id="data.id">
      <input placeholder="Select date" :disabled='disabled !== false' type="text" :value="value" class="form-control datepicker">
      <label for="date-picker">{{t(data.label)}}</label>
    </div>
  </div>
</template>


<script>
import { mapState } from 'vuex';

const $ = window.$;
const moment = window.moment;

export default {
  name: 'DatePicker',
  components: {
  },
  data() {
    return {
      picker: undefined,
      displayVal: '',
    };
  },
  props: {
    data: {
      default() {
        return { id: '', label: 'date' };
      },
    },
    value: { default: '' },
    aditionalClass: { default: '' },
    disabled: { default: false },
  },
  computed: {
    ...mapState({
      language: state => state.language,
      locales: state => state.locales, // [state.language].monthNames,
    }),
  },
  watch: {
  },
  methods: {
    getHumanDate(date) {
      return `${moment(date).format('D')} ${this.locales[this.language].monthNames[moment(date).format('M') - 1]}, ${moment(date).format('YYYY')}`; // eslint-disable-line
    },
    createPicker() {
      const pickerInput = $(`#${this.data.id} input`).pickadate({
        monthsFull: this.locales[this.language].monthNames,
      });
      this.picker = pickerInput.pickadate('picker');
      if (this.picker !== 'undefined') {
        if (typeof this.value !== 'undefined') {
          this.picker.set('select', this.getHumanDate(this.value));
        }
        this.picker.on('set', (args) => {
          // this.picker.set('select', this.getHumanDate(args.select));
          this.$emit('input', new Date(args.select));
        });
      }
      setTimeout(() => {
        if (typeof window.Materialize !== 'undefined') {
          if (typeof window.Materialize.updateTextFields !== 'undefined') {
            window.Materialize.updateTextFields();
          }
        }
      }, 0);
    },
  },
  mounted() {
    this.createPicker();
    if (typeof this.value !== 'undefined') {
      this.displayVal = this.getHumanDate(this.value);
    }
  },
};
</script>

<style lang="scss" scoped>
.lightOnDark {
  label {
    color: rgba(255, 255, 255, 0.7);
  }
  input {
    color: white;
  }
}

</style>



// WEBPACK FOOTER //
// DatePicker.vue?4836263c